import { type PublicationContext } from '~/types';

export default defineNuxtPlugin(() => {
  const pubCtx = useRuntimeConfig().public as unknown as PublicationContext;
  if (!!pubCtx.hubSpotMailChimpScript &&
    !!pubCtx.hubSpotMailChimpScript.src) {
    useHead({
      script: [
        {
          id: 'mcjs',
          key: 'hub-spot-mail-chimp',
          innerHTML: `!function(c,h,i,m,p){m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,"script","${pubCtx.hubSpotMailChimpScript.src}");`,
          async: true
        }
      ]
    });
  }
});
